enum ErrorStateMode {
  OnTouchedForm,
  OnSubmit,
  OnTouched,
  OnDirty,
}

enum OpenMethod {
  Window = 'window',
  Form = 'form',
}

export {
  ErrorStateMode,
  OpenMethod,
};
